<template>
    <va-create-layout>
        <auction-form :title="title" :item="item"></auction-form>
    </va-create-layout>
</template>

<script>
export default {
    props: ["title", "item"]
};
</script>
